class MCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartDrawerInner = this.querySelector(".m-cart-drawer__inner");
    this.cartDrawerCloseIcon = this.querySelector(".m-cart-drawer__close");
    this.cartOverlay = this.querySelector(".m-cart__overlay");
    this.rootUrl = window.Shopify.routes.root;

    this.setHeaderCartIconAccessibility();
    this.cartDrawerCloseIcon.addEventListener("click", this.close.bind(this));
    this.addEventListener("click", (event) => {
      if (event.target.closest(".m-cart-drawer__inner") !== this.cartDrawerInner) {
        this.close();
      }
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll(".m-cart-icon-bubble");
    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", (event) => {
        if (MinimogSettings.enable_cart_drawer) {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.classList.add("m-cart-drawer--active");
    requestAnimationFrame(() => {
      this.style.setProperty("--m-bg-opacity", "0.5");
      this.cartDrawerInner.style.setProperty("--translate-x", "0");
    });
    window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
    document.documentElement.classList.add("prevent-scroll");
  }

  close() {
    this.style.setProperty("--m-bg-opacity", "0");
    this.cartDrawerInner.style.setProperty("--translate-x", "100%");
    setTimeout(() => {
      this.classList.remove("m-cart-drawer--active");
      document.documentElement.classList.remove("prevent-scroll");
    }, 300);
  }

  renderContents(parsedState) {
    this.classList.contains("m-cart--empty") && this.classList.remove("m-cart--empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    setTimeout(() => {
      this.open();
    });
  }

  updateCartCount(itemCount) {
    const cartCounts = document.querySelectorAll(".m-cart-count-bubble");
    cartCounts.forEach((cartCount) => {
      if (itemCount > 0) {
        cartCount.textContent = itemCount;
        cartCount.classList.remove("m:hidden");
      } else {
        cartCount.classList.add("m:hidden");
      }
    });
  }

  getCart() {
    return fetchJSON(this.rootUrl + "cart.json");
  }

  onCartDrawerUpdate(updateFooter = true) {
    fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        this.getSectionsToRender().forEach((section) => {
          if (section.block === "cart-items") {
            const sectionElement = section.selector
              ? document.querySelector(section.selector)
              : document.getElementById(section.id);
            sectionElement.innerHTML = this.getSectionInnerHTML(responseText, section.selector);
          } else {
            if (updateFooter) {
              const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);
              sectionElement.innerHTML = this.getSectionInnerHTML(responseText, section.selector);
            }
          }
        });
      })
      .catch((e) => {
        console.error(e);
      });
    this.getCart().then((cart) => {
      this.classList.toggle("m-cart--empty", cart.item_count === 0);
      this.updateCartCount(cart.item_count);
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "[data-minimog-cart-items]",
        block: "cart-items",
      },
      {
        id: "cart-drawer",
        selector: "[data-minimog-cart-discounts]",
        block: "cart-footer",
      },
      {
        id: "cart-drawer",
        selector: "[data-cart-subtotal]",
        block: "cart-footer",
      },
      {
        id: "cart-drawer",
        selector: "[data-minimog-gift-wrapping]",
        block: "cart-footer",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("m-cart-drawer", MCartDrawer);

class MCartDrawerItems extends MCartTemplate {
  getSectionsToRender() {
    return [
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-cart-items]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-cart-discounts]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-cart-subtotal]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-gift-wrapping]",
      },
    ];
  }
}

customElements.define("m-cart-drawer-items", MCartDrawerItems);

/* ============================================================
   ZELSU CART DRAWER ENHANCEMENTS
   Tabs · Recently Viewed · Recommendations Slider
   ============================================================ */

class ZelsuCartDrawerEnhancer {
  constructor() {
    this.drawer = document.getElementById("MinimogCartDrawer");
    if (!this.drawer) return;

    this.recProducts = [];
    this.recFetched = false;
    this.slideIndex = 0;

    this._initTabs();
    this._initSliderControls();
    this._initOverlayCursor();
    this._watchDrawerOpen();
    this._watchCartItems();
  }

  /* ---- Overlay cursor ---- */
  _initOverlayCursor() {
    const cursor = this.drawer.querySelector(".zcd-cursor");
    const inner = this.drawer.querySelector(".m-cart-drawer__inner");
    if (!cursor || !inner) return;

    const half = 27; // half of 54px cursor size
    let rafId = null;
    let cx = 0, cy = 0;

    const moveCursor = (x, y) => {
      cursor.style.left = (x - half) + "px";
      cursor.style.top  = (y - half) + "px";
    };

    this.drawer.addEventListener("mousemove", (e) => {
      cx = e.clientX; cy = e.clientY;
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        moveCursor(cx, cy);
        const overInner = inner.contains(e.target) || inner === e.target;
        const isOpen = this.drawer.classList.contains("m-cart-drawer--active");
        if (!overInner && isOpen) {
          cursor.classList.add("zcd-cursor--visible");
        } else {
          cursor.classList.remove("zcd-cursor--visible");
        }
      });
    });

    this.drawer.addEventListener("mouseleave", () => {
      cursor.classList.remove("zcd-cursor--visible");
    });

    // Hide cursor when entering the inner panel
    inner.addEventListener("mouseenter", () => {
      cursor.classList.remove("zcd-cursor--visible");
    });
  }

  /* ---- Tab switching ---- */
  _initTabs() {
    this.drawer.querySelectorAll(".zcd-tab").forEach((tab) => {
      tab.addEventListener("click", () => this._switchTab(tab.dataset.tab));
    });
  }

  _switchTab(name) {
    this.drawer.querySelectorAll(".zcd-tab").forEach((t) => {
      const on = t.dataset.tab === name;
      t.classList.toggle("zcd-tab--active", on);
      t.setAttribute("aria-selected", String(on));
    });
    this.drawer.querySelectorAll(".zcd-panel").forEach((p) => {
      const on = p.dataset.panel === name;
      p.classList.toggle("zcd-panel--active", on);
      p.hidden = !on;
    });
    if (name === "recently-viewed") this._renderRecentlyViewed();
  }

  /* ---- Recently Viewed ---- */
  _renderRecentlyViewed() {
    const grid = this.drawer.querySelector("[data-rv-grid]");
    const empty = this.drawer.querySelector("[data-rv-empty]");
    if (!grid) return;

    let items = [];
    try { items = JSON.parse(localStorage.getItem("zelsu_recently_viewed") || "[]"); } catch (e) {}

    if (!items.length) {
      grid.innerHTML = "";
      if (empty) empty.style.display = "flex";
      return;
    }
    if (empty) empty.style.display = "none";

    grid.innerHTML = items
      .map(
        (p) => `<a href="${p.url}" class="zcd-rv-card">
        <div class="zcd-rv-card__img">
          ${p.image ? `<img src="${p.image}" alt="${this._esc(p.title)}" loading="lazy">` : ""}
        </div>
        <div class="zcd-rv-card__info">
          <div class="zcd-rv-card__title">${this._esc(p.title)}</div>
          <div class="zcd-rv-card__price">${this._esc(p.price)}</div>
        </div>
      </a>`
      )
      .join("");
  }

  /* ---- Recommendations slider ---- */
  _initSliderControls() {
    this.track = this.drawer.querySelector("[data-related-track]");
    this.prevBtn = this.drawer.querySelector(".zcd-related__prev");
    this.nextBtn = this.drawer.querySelector(".zcd-related__next");

    if (this.prevBtn) this.prevBtn.addEventListener("click", () => this._slide(-1));
    if (this.nextBtn) this.nextBtn.addEventListener("click", () => this._slide(1));
  }

  _fetchRecommendations() {
    const pids = this._allProductIds();
    if (!pids.length || !this.track) return;

    this.recFetched = true;
    const cartIdSet = new Set(pids.map(String));

    // Fetch recommendations for EVERY product in cart, then merge & deduplicate
    const fetches = pids.map((pid) =>
      fetch(`/recommendations/products.json?product_id=${pid}&limit=6&intent=related`)
        .then((r) => r.json())
        .then(({ products = [] }) => products)
        .catch(() => [])
    );

    Promise.all(fetches).then((results) => {
      const seen = new Set();
      const merged = [];
      // Interleave results so each category contributes equally
      const maxLen = Math.max(...results.map((r) => r.length));
      for (let i = 0; i < maxLen; i++) {
        results.forEach((group) => {
          if (i < group.length) {
            const p = group[i];
            if (!seen.has(p.id) && !cartIdSet.has(String(p.id))) {
              seen.add(p.id);
              merged.push(p);
            }
          }
        });
      }
      this.recProducts = merged.slice(0, 12);
      this._renderRecommendations();
    }).catch(() => {
      const root = this.drawer.querySelector("[data-related-root]");
      if (root) root.style.display = "none";
    });
  }

  _renderRecommendations() {
    if (!this.track) return;
    const root = this.drawer.querySelector("[data-related-root]");

    if (!this.recProducts.length) {
      if (root) root.style.display = "none";
      return;
    }

    this.slideIndex = 0;
    this.track.innerHTML = this.recProducts
      .map((p) => {
        const img =
          typeof p.featured_image === "string"
            ? p.featured_image
            : p.featured_image?.src || (p.images && p.images[0]?.src) || "";
        const price = this._money(p.price_varies ? p.price_min : p.price);
        return `<div class="zcd-rec-card">
          <div class="zcd-rec-card__img">
            ${img ? `<img src="${img}" alt="${this._esc(p.title)}" loading="lazy">` : ""}
          </div>
          <div class="zcd-rec-card__body">
            <div class="zcd-rec-card__title">${this._esc(p.title)}</div>
            <div class="zcd-rec-card__price">${price}</div>
            <a href="/products/${p.handle}" class="zcd-rec-card__btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              View
            </a>
          </div>
        </div>`;
      })
      .join("");

    this.track.style.transform = "";
    this._updateNav();
  }

  _slide(dir) {
    const cards = this.track ? [...this.track.querySelectorAll(".zcd-rec-card")] : [];
    if (!cards.length) return;

    const gap = 10;
    const cardW = cards[0].offsetWidth + gap;
    const viewW = this.track.parentElement.offsetWidth;
    const visible = Math.max(1, Math.floor(viewW / cardW));
    const max = Math.max(0, cards.length - visible);

    this.slideIndex = Math.max(0, Math.min(this.slideIndex + dir, max));
    this.track.style.transform = `translateX(-${this.slideIndex * cardW}px)`;
    this._updateNav();
  }

  _updateNav() {
    const cards = this.track ? [...this.track.querySelectorAll(".zcd-rec-card")] : [];
    if (!cards.length) return;

    const gap = 10;
    const cardW = cards[0].offsetWidth + gap;
    const viewW = this.track.parentElement ? this.track.parentElement.offsetWidth : 0;
    const visible = Math.max(1, Math.floor(viewW / cardW));
    const max = Math.max(0, cards.length - visible);

    if (this.prevBtn) this.prevBtn.disabled = this.slideIndex === 0;
    if (this.nextBtn) this.nextBtn.disabled = this.slideIndex >= max;
  }

  /* ---- Lifecycle hooks ---- */
  _watchDrawerOpen() {
    let wasOpen = false;
    new MutationObserver(() => {
      const isOpen = this.drawer.classList.contains("m-cart-drawer--active");
      if (isOpen && !wasOpen) {
        wasOpen = true;
        this._onOpen();
      } else if (!isOpen) {
        wasOpen = false;
      }
    }).observe(this.drawer, { attributes: true, attributeFilter: ["class"] });
  }

  _onOpen() {
    if (!this.recFetched) this._fetchRecommendations();
    this._syncTabBadge();
  }

  _watchCartItems() {
    const itemsEl = this.drawer.querySelector("[data-minimog-cart-items]");
    if (!itemsEl) return;

    let prevKey = this._allProductIds().join(",");

    new MutationObserver(() => {
      this._syncTabBadge();
      const newKey = this._allProductIds().join(",");
      if (newKey !== prevKey) {
        prevKey = newKey;
        this.recFetched = false;
        this.recProducts = [];
        this.track = this.drawer.querySelector("[data-related-track]");
        this._fetchRecommendations();
      }
    }).observe(itemsEl, { childList: true, subtree: false });
  }

  /* ---- Helpers ---- */
  _allProductIds() {
    const els = this.drawer.querySelectorAll("[data-cart-item][data-product-id]");
    const seen = new Set();
    const ids = [];
    els.forEach((el) => {
      const id = el.dataset.productId;
      if (id && !seen.has(id)) {
        seen.add(id);
        ids.push(id);
      }
    });
    return ids;
  }

  _firstProductIdFromDOM() {
    const el = this.drawer.querySelector("[data-cart-item][data-product-id]");
    return el ? el.dataset.productId : null;
  }

  _syncTabBadge() {
    const badge = this.drawer.querySelector("[data-cart-tab-count]");
    if (!badge) return;
    const isEmpty = this.drawer.classList.contains("m-cart--empty");
    // Minimog hides bubble with m:hidden when empty but leaves stale text — check visibility
    const visibleBubble = document.querySelector(".m-cart-count-bubble:not(.m\\:hidden)");
    const count = (!isEmpty && visibleBubble) ? (visibleBubble.textContent.trim() || "0") : "0";
    badge.textContent = count;
    badge.hidden = count === "0";
  }

  _money(cents) {
    if (cents == null || cents === false) return "";
    const amount = Math.round(cents) / 100;
    const fmt = (window.MinimogSettings && (MinimogSettings.money_format || MinimogSettings.money_with_currency_format))
      || "Rs. {{amount}}";

    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, fmt);
    }

    // Manual fallback — replace Shopify money tokens
    const noDecimals = amount.toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const withDecimals = amount.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt
      .replace("{{amount_no_decimals_with_comma_separator}}", noDecimals)
      .replace("{{amount_with_comma_separator}}", withDecimals)
      .replace("{{amount_no_decimals}}", noDecimals)
      .replace("{{amount}}", withDecimals);
  }

  _esc(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new ZelsuCartDrawerEnhancer();
});
